import { render, staticRenderFns } from "./AddNewModal.vue?vue&type=template&id=afbc0900&"
import script from "./AddNewModal.vue?vue&type=script&lang=js&"
export * from "./AddNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports